import { Assistant } from "@genai/assistant";

export function initialMessageFromAssistant(
  assistant: Assistant | undefined,
): string {
  return (
    assistant?.introduction ||
    `Hello, I am ${assistant?.name} , how can I help you today ?`
  );
}
